/*
 * author: wendux
 * email: 824783146@qq.com
 * source code: https://github.com/wendux/Ajax-hook
 */

import { hook } from "./xhr-hook";
import { proxy } from "./xhr-proxy";
// ah(ajax hook)
export var ah = {
    proxy,
    hook,
};



// WEBPACK FOOTER //
// ./src/cdn.js